import dynamic from "next/dynamic";

export const OrganisationCards = dynamic(() => import("./component"));
